export default __webpack_public_path__ + "static/media/announcement.1a739f4e.svg";